
import { Link } from "react-router-dom";
import { Mail, Clock } from "lucide-react";

export const EnglishContactInfo = () => {
  return (
    <div className="mt-12 mb-8 p-6 bg-blue-50 rounded-lg">
      <h2 className="text-xl font-semibold mb-4 text-blue-700">Need help with your application?</h2>
      <p className="mb-4">Our customer service is available to assist you with any questions about loans or the application process.</p>
      
      <div className="space-y-3">
        <div className="flex items-center">
          <Mail className="h-5 w-5 text-blue-600 mr-3" />
          <span>Email: <a href="mailto:asiakaspalvelu@lainasampo.fi" className="text-blue-600 hover:underline">asiakaspalvelu@lainasampo.fi</a></span>
        </div>
        
        <div className="flex items-center">
          <Clock className="h-5 w-5 text-blue-600 mr-3" />
          <span>Customer service hours: Mon-Fri 9:00-17:00</span>
        </div>
      </div>
      
      <div className="mt-6">
        <Link 
          to="/english/apply" 
          className="inline-block text-blue-600 font-medium hover:underline"
        >
          Return to loan application
        </Link>
      </div>
    </div>
  );
};
